<template>
  <router-view name="login"></router-view>
  <router-view name="register"></router-view>
  <router-view></router-view>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useStore } from "vuex";
// import { getMaintenanceStatus } from "./api";

const store = useStore();

// 检查维护状态（只在应用启动时调用一次）
const checkMaintenanceStatus = async () => {
  try {
    // const res = await getMaintenanceStatus();
    // if (res?.code === "success" && res.content) {
    //   const maintenanceInfo = res.content as {
    //     isMaintenance?: boolean;
    //     message?: string;
    //     startTime?: string;
    //     endTime?: string;
    //   };
    //   // 将维护信息存储到 store
    //   store.dispatch("maintenance/setMaintenanceInfo", maintenanceInfo);
    // }

    store.dispatch("maintenance/setMaintenanceInfo", {
      isMaintenance: false,
      message: "系统正在维护升级，请稍后再试",
      startTime: "2025-12-17 10:00:00",
      endTime: "2025-12-17 12:00:00",
    });
  } catch (error) {
    console.warn("检查维护状态失败:", error);
  }
};

// 应用启动时（刷新页面）检查维护状态
onMounted(() => {
  checkMaintenanceStatus();
});
</script>
